import styled from "styled-components";
import { Drawer } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .ant-row {
    label {
      display: inline-block;
      margin-top: 8px;
      margin-bottom: 8px;
      font-family: "Asap", sans-serif;
      color: #9074bf;
      font-size: 14px;
      font-weight: bold;

      #bovexoInfoIcon {
        margin-left: 3px;
      }

      &.disabled {
        font-weight: bold;
        font-size: 14px;
        color: #c4c4c4;
      }
    }
  }

  .error {
    color: #d44c4c !important;
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }
`;

export const Body = styled.div`
  width: 100%;
  padding: 0px 24px;
  min-height: -moz-calc(100vh - 165px);
  min-height: -webkit-calc(100vh - 165px);
  min-height: calc(100vh - 165px);

  .lotMessage {
    font-family: Asap;
    font-weight: normal;
    font-size: 16px;
    text-align: left;
    color: #4b4b4b;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button:first-of-type {
      margin-right: 12px !important;
    }
  }

  .ant-row-flex {
    margin: 0;
  }

  .selectDiv {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-family: "Asap", sans-serif;
      font-size: 14px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;
